'use strict';

/**
 * @ngdoc function
 * @name bakuAppApp.factory:Session
 * @description
 * # Session Factory
 * Factory of the bakuAppApp
 */

angular.module('thothApp.services')
  .factory('Session', [
    '$auth', '$state', '$rootScope', 'toaster', '$window', 'GoogleApi',
    function($auth, $state, $rootScope, toaster, $window, GoogleApi) {
      return {
        logout: function() {
          GoogleApi.logout();
        },
        login: function(sessionParams) {
          // Do Login with API
          return $auth.login(sessionParams).then(function(response) {
            $rootScope.isAuthenticated = true;
            // jscs:disable
            $auth.setToken(response.data.meta.token);
            // jscs:enable

            return $state.go('app.projects.list');
          })['catch'](function(error) {
            toaster.pop('error', 'Credenciales Invalidas', error.data.errors);
            return console.log(error);
          });
        }
      };
    }
  ]);
